import type { MouseEvent, ReactNode } from 'react';

import { cn } from '@nesso/ui/lib/utils';
import { Badge } from '@nesso/ui/primitives/badge';

type Props = {
    value: string;
    label: string;
    icon: ReactNode;
    onRemove: (value: string) => void;
    disabled?: boolean;
    className?: string;
};

export function MultiSelectBadge({ value, label, icon, onRemove, disabled, className }: Props) {
    const handleClick = (e: MouseEvent) => {
        e.stopPropagation();
        onRemove(value);
    };

    return (
        <Badge
            asChild
            variant="outline"
            className={cn(
                'flex max-w-full items-center gap-1.5 rounded-full pl-2 pr-0.5 font-normal',
                className,
            )}
        >
            <button
                type="button"
                tabIndex={0}
                aria-label={`Remove ${label}`}
                disabled={disabled}
                onClick={handleClick}
            >
                <span className="max-w-70 whitespace-normal text-[0.8125rem]">{label}</span>
                <span className="shrink-0 opacity-70">{icon}</span>
            </button>
        </Badge>
    );
}
